import { Link, Status, tableClassNames } from '@chocolate-soup-inc/cs-frontend-components';
import clsx from 'clsx';
import { TCarriers, TGiftStatuses, TShipmentFieldsFragment, TShipmentStatuses } from '../../generated/graphql';
import { TGift } from '../gifts/utils';

export const getFinalGiftStatus = (gift?: TGift | null) => {
  if (!gift?.status) return 'Unavailable';
  const { status } = gift || {};

  switch (status) {
    case TGiftStatuses.Todo:
      return 'Gift Todo';
    case TGiftStatuses.Assembling:
      return 'Gift Assembling';
    case TGiftStatuses.Qa:
      return 'Gift QA';
    case TGiftStatuses.Done:
      return 'Gift Done';
    default:
      return 'Unavailable';
  }
};

export const getFinalGiftColor = (gift?: TGift | null) => {
  if (!gift?.status) return '#92979D';
  const { status } = gift || {};

  switch (status) {
    case TGiftStatuses.Todo:
      return '#F03738';
    case TGiftStatuses.Assembling:
      return '#F3BB1C';
    case TGiftStatuses.Qa:
      return '#3E66FB';
    case TGiftStatuses.Done:
      return '#66CA65';
    default:
      return '#92979D';
  }
};

export const GiftStatusCell = (gift?: TGift | null) => {
  const text = getFinalGiftStatus(gift);
  const color = getFinalGiftColor(gift);

  return (
    <Status className={tableClassNames.primary} color={color}>
      {text}
    </Status>
  );
};

export const getShipmentFinalStatus = (shipment?: TShipmentFieldsFragment | null) => {
  if (shipment?.label?.carrier === TCarriers.Ups) return 'Unavailable';
  const { status } = shipment || {};

  switch (status) {
    case TShipmentStatuses.Packaging:
      return 'Shipment Assembling';
    case TShipmentStatuses.ReadyToShip:
    case TShipmentStatuses.PrintingLabel:
      return 'Awaiting Shipment';
    case TShipmentStatuses.LabelPrinted:
      return 'Shipping Label Printed';
    case TShipmentStatuses.Shipped:
      return 'In Transit';
    case TShipmentStatuses.Delivered:
      return 'Delivered';
    case TShipmentStatuses.ReadyForPickup:
      return 'Available for Pickup';
    case TShipmentStatuses.Returned:
      return 'Returned';
    case TShipmentStatuses.PickedUp:
      return 'Picked Up';
    case TShipmentStatuses.Unavailable:
    default:
      return 'Unavailable';
  }
};

export const getShipmentFinalColor = (shipment?: TShipmentFieldsFragment | null) => {
  if (shipment?.label?.carrier === TCarriers.Ups) return '#92979D';
  const { status } = shipment || {};

  switch (status) {
    case TShipmentStatuses.Packaging:
    case TShipmentStatuses.ReadyToShip:
    case TShipmentStatuses.PrintingLabel:
    case TShipmentStatuses.Unavailable:
    default:
      return '#92979D';
    case TShipmentStatuses.LabelPrinted:
    case TShipmentStatuses.Shipped:
      return '#3E66FB';
    case TShipmentStatuses.Delivered:
    case TShipmentStatuses.PickedUp:
      return '#66CA65';
    case TShipmentStatuses.ReadyForPickup:
      return '#F3BB1C';
    case TShipmentStatuses.Returned:
      return '#F03738';
  }
};

export const ShipmentStatusCell = (shipment?: TShipmentFieldsFragment | null) => {
  const text = getShipmentFinalStatus(shipment);
  const color = getShipmentFinalColor(shipment);

  return (
    <Status className={tableClassNames.primary} color={color}>
      {text}
    </Status>
  );
};

export const getTrackingLink = (shipment: TShipmentFieldsFragment) => {
  const { trackingNumber, label } = shipment;
  const { carrier = undefined } = label || {};

  switch (carrier) {
    case 'canada_post':
      return `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${trackingNumber}`;
    case 'purolator_ca':
      return `https://www.purolator.com/en/shipping/tracker?pin=${trackingNumber}`;
    case 'dhl_express_canada':
      return `https://www.dhl.com/br-en/home/tracking/tracking-express.html?submit=1&tracking-id=${trackingNumber}`;
    case 'ups':
      return `https://www.ups.com/track?track=yes&trackNums=${trackingNumber}&loc=en_US&requester=ST/trackdetails`;
    default:
      break;
  }
};

export const TrackingLink = (shipment: TShipmentFieldsFragment) => {
  return (
    <div className={clsx(tableClassNames.primary)}>
      {shipment.trackingNumber ? (
        <Link
          href={getTrackingLink(shipment)}
          label={shipment.trackingNumber}
          icon={true}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            e.preventDefault();

            window.open(getTrackingLink(shipment));
          }}
        />
      ) : (
        '-'
      )}
    </div>
  );
};
